import { Component, Input, OnInit } from '@angular/core';
@Component({
    selector: 'simple-icons-metafilter',
    template: `<svg class="simple-icons {{ className }}" [style.width]="size" [style.height]="size" [style.fill]="color" role="img" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><title>MetaFilter icon</title><path d="M18.548 5.26l-.87 4.894h3.558l-.519 2.83h-3.592l-1.602 8.639h-2.857l3.586-19.248H24l-.537 2.885h-4.915zm-7.331-2.884L7.19 13.472V2.376H3.581L0 21.624h2.452L5.198 6.728l-.251 14.896h1.421l5.225-14.896-2.786 14.896h2.48l3.581-19.248h-3.651z"/></svg>`,
    styles: []
})
export class SimpleIconsMetafilterComponent implements OnInit {
    @Input() size: string = '100%';
    @Input() color: string = '#065A8F';
    @Input() className: string = 'simple-icons-metafilter'
    constructor() {}
    ngOnInit(): void {}
}
